import SystemError from './system.error'

export default SystemError
